import { render, staticRenderFns } from "./EchoApi.vue?vue&type=template&id=5f823c9e&"
import script from "./EchoApi.vue?vue&type=script&lang=js&"
export * from "./EchoApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports